import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { appReset,appSetRoute } from './store/actions';

import Cservices from './containers/Cservices';
import Layout from './components/Layout';

import Cdeliv from './containers/Cdeliv';
import Cinitial from './containers/Cinitial';
import Clogin from './containers/Clogin';
import CmsgDialog from './containers/CmsgDialog';
import Corders from './containers/Corders';
import Cplate from './containers/Cplate';
import Cprofile from './containers/Cprofile';
import Csensors from './containers/Csensors';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#DB4437'
    },
    secondary: {
      main: '#333'
    }
  }
});

class App extends Component {
  render() {
    if (document.location.pathname!=='/'){
      document.location.href="/";
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Layout>
          <Router>
            <Fragment>
              <CmsgDialog />
              <Cservices/>
              <Route exact path="/" component={Cinitial} />
              <Route exact path="/login" component={Clogin} />
              <Route exact path="/deliv" component={Cdeliv} />
              <Route exact path="/orders" component={Corders} />
              <Route exact path="/plate" component={Cplate} />
              <Route exact path="/profile" component={Cprofile} />
              <Route exact path="/sensors" component={Csensors} />
            </Fragment>
          </Router>
        </Layout>
      </MuiThemeProvider>
    )
  }
}

const mapStateToProps = state => {
  return {
      loginState: state.app.loginState
  }
}

const mapDispatchToProps = dispatch => {
  return {
      appReset: () => dispatch(appReset()),
      appSetRoute: (route) => dispatch(appSetRoute(route))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js